
import React, { useState } from 'react';
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogBody } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Sparkles } from 'lucide-react';

interface CustomPromptDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (promptText: string) => void;
  type: 'email' | 'call';
  isLoading: boolean;
}

const CustomPromptDialog: React.FC<CustomPromptDialogProps> = ({
  isOpen,
  onClose,
  onSubmit,
  type,
  isLoading
}) => {
  const [promptText, setPromptText] = useState('');

  const handleSubmit = () => {
    onSubmit(promptText);
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Customize {type === 'email' ? 'Email' : 'Call Script'} Generation</DialogTitle>
          <DialogDescription>
            Provide additional information or a draft to enhance the AI-generated {type === 'email' ? 'email' : 'call script'}.
          </DialogDescription>
        </DialogHeader>
        
        <DialogBody>
          <div className="space-y-2">
            <Label htmlFor="customPrompt">Additional Instructions</Label>
            <Textarea
              id="customPrompt"
              placeholder={type === 'email' 
                ? "Enter any details you want included in the email, a draft email, or specific talking points..."
                : "Enter any details you want included in the call script, key talking points, or specific questions..."}
              className="min-h-[150px]"
              value={promptText}
              onChange={(e) => setPromptText(e.target.value)}
            />
            <p className="text-sm text-muted-foreground">
              Leave blank to generate a standard template based on the lead profile.
            </p>
          </div>
        </DialogBody>
        
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isLoading}>Cancel</Button>
          <Button onClick={handleSubmit} disabled={isLoading}>
            {isLoading ? 'Generating...' : (
              <>
                <Sparkles className="mr-2 h-4 w-4" />
                Generate with AI
              </>
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CustomPromptDialog;
